import type {
  GraphMode,
  PathLookupGraphPreset,
  TopologyGraphPreset,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';

export const getPresetDraftFunctionByMode: {
  [Key in GraphMode]: (
    s: GraphState,
  ) => TopologyGraphPreset | PathLookupGraphPreset;
} = {
  pathLookup: prop('pathlookup', 'presetDraft'),
  topology: prop('layoutSettings', 'presetDraft'),
};

export const getPresetFunctionByMode: {
  [Key in GraphMode]: (
    s: GraphState,
  ) => TopologyGraphPreset | PathLookupGraphPreset;
} = {
  pathLookup: prop('pathlookup', 'preset'),
  topology: prop('layoutSettings', 'preset'),
};
